import React, { useState, useEffect } from 'react';
import CookieConsentForm from './CookieConsentForm';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  useEffect(() => {
    // Prüfen, ob der Benutzer bereits Einstellungen vorgenommen hat
    const hasConsent = localStorage.getItem('cookieSettings');
    // Banner nur anzeigen, wenn noch keine Entscheidung getroffen wurde
    if (!hasConsent) {
      // Kurze Verzögerung, damit der Banner nicht sofort erscheint
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  // Event-Listener für das Öffnen der Cookie-Einstellungen aus dem Footer
  useEffect(() => {
    const handleOpenSettings = () => {
      setShowSettings(true);
    };

    window.addEventListener('openCookieSettings', handleOpenSettings);
    
    return () => {
      window.removeEventListener('openCookieSettings', handleOpenSettings);
    };
  }, []);

  const handleAcceptAll = () => {
    const allAccepted = {
      necessary: true,
      functional: true,
      analytics: true,
      marketing: true
    };
    localStorage.setItem('cookieSettings', JSON.stringify(allAccepted));
    setShowBanner(false);
  };

  const handleRejectAll = () => {
    const minimal = {
      necessary: true,
      functional: false,
      analytics: false,
      marketing: false
    };
    localStorage.setItem('cookieSettings', JSON.stringify(minimal));
    setShowBanner(false);
  };

  const openSettings = () => {
    setShowSettings(true);
    setShowBanner(false);
  };

  const closeSettings = () => {
    setShowSettings(false);
  };

  if (!showBanner && !showSettings) return null;

  return (
    <>
      {/* Cookie-Banner */}
      {showBanner && (
        <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <div className="md:flex md:items-center md:justify-between">
              <div className="flex-1 min-w-0 md:max-w-2xl">
                <h2 className="text-xl font-serif text-gray-800 mb-2">Wir respektieren Ihre Privatsphäre</h2>
                <p className="text-gray-600 text-sm">
                  Wir verwenden Cookies, um Ihnen die bestmögliche Erfahrung auf unserer Website zu bieten, 
                  Inhalte und Werbung zu personalisieren, Social-Media-Funktionen bereitzustellen und unseren 
                  Datenverkehr zu analysieren.
                </p>
              </div>
              <div className="mt-4 md:mt-0 flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-2">
                <button 
                  onClick={openSettings} 
                  className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                >
                  Einstellungen
                </button>
                <button 
                  onClick={handleRejectAll} 
                  className="px-4 py-2 border border-primary bg-white text-primary rounded-md hover:bg-primary hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                >
                  Nur notwendige
                </button>
                <button 
                  onClick={handleAcceptAll} 
                  className="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary-dark transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                >
                  Alle akzeptieren
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Cookie-Einstellungsformular */}
      <CookieConsentForm isOpen={showSettings} onClose={closeSettings} />
    </>
  );
};

export default CookieBanner; 
